import axios from 'axios';
import uuid from 'uuid';
import { SESSION, SESSION_UUID, SESSION_USERNAME, SESSION_USERTYPE } from "./shared/Constants";
import Cookies from 'js-cookie';

const ADM_SVC_API_URL = process.env.REACT_APP_ADMIN_SERVICE_HOST + process.env.REACT_APP_ADMIN_SERVICE_BASE_PATH;

const instance = axios.create({
    baseURL: ADM_SVC_API_URL,
    timeout: 13000,
    withCredentials: true
});

instance.defaults.headers.common['Accept'] = 'application/json';
// instance.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
instance.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
instance.defaults.headers.common['Access-Control-Allow-Methods'] = ['GET', 'POST', 'PUT', 'OPTIONS'];
instance.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
instance.defaults.headers.post['Content-Type'] = 'application/json';

instance.interceptors.request.use( request => {
    let audit = {
        transactionId: uuid.v4(),
        sessionId: localStorage.getItem(SESSION),
        timestamp: (new Date()).toLocaleString()
    }
    request.headers["audit"] = audit;
    request.headers["OPTUM-CID-EXT"] = "HSID-admin-tool-"+localStorage.getItem(SESSION_UUID);
    request.headers["adminUserId"] = localStorage.getItem(SESSION_USERNAME);
    request.headers["agentType"] = localStorage.getItem(SESSION_USERTYPE);
    const csrfToken = Cookies.get('XSRF-TOKEN');
    if (csrfToken) {
       axios.defaults.headers.common['X-XSRF-TOKEN'] = csrfToken;
    }
    //console.log("[Axios Admn Svc] Request Interceptor:", request);
    return request;
}, error => {
    //console.log("[Axios Admn Svc] Request Interceptor: Error:", error);
    return Promise.reject(error);
});

instance.interceptors.response.use( response => {
    //console.log("[Axios Admn Svc] Response Interceptor:", response);
    return response;
}, error => {
    //console.log("[Axios Admn Svc] Response Interceptor: Error:", error);
    return Promise.reject(error);
});

export default instance;
